export default "__VITE_ASSET__bDVV7ZKb__"